import React, { useEffect, useRef } from 'react';
import '../Animations.css'
import { useState } from 'react';
import Input, { inputColors, inputSizes } from '../../../Objects/Input/Input';
import { btnColors, btnSizes } from '../../../Objects/CommonButton/CommonButton';
import TimerComponent from "../../../Objects/TimerComponent"
import { firebaseCommands } from '../Game';
import {
    playBgm,
    stopBgm,
    playFx,
    primeBuffers,
    isUnlocked,
    getAudioTime,
    getBufferDuration,
} from '../../../audio/audioManager';

//MUSIC
import bgm_audio from "../../../assets/musics/bgm_loop.mp3";
import showScore_audio_1 from "../../../assets/musics/showScore_1.mp3";
import introBg from "../../../assets/musics/Intro.mp3";
import inBetween from "../../../assets/musics/inBetween.mp3";
import showScore_last_audio from "../../../assets/musics/showScore_last.mp3";

//EFFECTS
import double_up_audio from "../../../assets/sounds/double_up.mp3"
import correct_audio from "../../../assets/sounds/correct.mp3"
import new_word_audio from "../../../assets/sounds/new_word.mp3"
import ready_audio from "../../../assets/sounds/ready.mp3"
import time_out_audio from "../../../assets/sounds/time_out.mp3"
import wrong_audio from "../../../assets/sounds/wrong.mp3"

// Tutto l'audio del gioco: lo riproduce solo il display, il pulsante non scarica né decodifica nulla.
// Game li prepara già nel lobby (solo sul display), per averli pronti prima che servano.
export const displayTracks = [
    { name: 'bgm', url: bgm_audio },
    { name: 'showScore', url: showScore_audio_1 },
    { name: 'showScore_last', url: showScore_last_audio },
    { name: 'cutscene_intro', url: introBg },
    { name: 'cutscene_inbetween', url: inBetween },
    { name: 'double_up', url: double_up_audio },
    { name: 'correct', url: correct_audio },
    { name: 'new_word', url: new_word_audio },
    { name: 'ready', url: ready_audio },
    { name: 'time_out', url: time_out_audio },
    { name: 'wrong', url: wrong_audio },
];

export const gameStatus_display = {
    showTeam: 1,
    showBox: 2,
    newWord: 3,
    guessWord: 4,
    wrong: 5,
    correct: 6,
    skip: 7,
    double: 8,
    showResults: 9,
    lastGuess: 10,
    guessing: 11,
    pause: 12,
    resume: 13,
    lastResults: 14,
    endGame: 15,
}

//step in cui la parola è in gioco e il timer può scorrere
const WORD_STEPS = [gameStatus_display.newWord, gameStatus_display.guessing, gameStatus_display.double];

const Game_display = ({ game, teams, changeGame, changeTeams, words, doubleWords,
    customWords, customDoubleWords, readKeys, setReadKeys, readDoubleKeys, setReadDoubleKeys,
    readCustomKeys, setCustomReadKeys, readCustomDoubleKeys, setCustomReadDoubleKeys,
    forceStandards, forceDoubleStandards, musicVolume, effectsVolume, percent, nextCutsceneTrack, setCutsceneAudioExternal}) => {
    
    const [curTeam, setCurTeam] = useState("");
    let team = useRef(null);
    let word = useRef(null);
    let score = useRef(null);
    let time = useRef(null);

    // BGM: un solo file (intro + loop). Punti in campioni a 44,1 kHz, verificati sulla forma d'onda:
    // da 2.568.529 la coda del file ripete esattamente la musica che parte da 78.161 (loop senza salti)
    const BGM_LOOP_START = 78161 / 44100; // secondi: l'intro (0 -> start) si suona una volta sola
    const BGM_LOOP_END = 2568529 / 44100; // secondi: la coda oltre questo punto non viene mai suonata
    const bgmActive = useRef(false);
    const bgmToken = useRef(0);
    const timerPausedForVisibility = useRef(false);
    const showScoreSequencePlayed = useRef(false);

    const [timer, setTimer] = useState({
        active: false,
        timeLeft: 60
    });
    const timerRef = useRef(timer);
    timerRef.current = timer;

    //ogni parola ha un numero: roulette e ingresso della parola (passaggi differiti) valgono solo se nel frattempo non è
    //partita un'altra parola. Il timer riparte solo se il gioco è ancora in uno step in cui la parola si indovina: se
    //"indovina" arriva mentre gira la roulette il timer non va riacceso. stepRef segue lo step dell'ultimo render,
    //che per quei passaggi è già avvenuto
    const wordToken = useRef(0);
    const stepRef = useRef(game.step);
    stepRef.current = game.step;

    const startTimerFor = (token) => {
        if (token === wordToken.current && WORD_STEPS.includes(stepRef.current)) {
            setTimer((prevState) => ({
                ...prevState,
                active: true,
            }));
        }
    };

    const [turnTimer, setTurnTimer] = useState({
        active: false,
        timeLeft: 6
    });

    let wordClass = "wordContainer " + inputColors.done;
    let mini_cl1 = "mini-side";
    let mini_cl2 = "mini-side";
    //console.log("CUR 1: ",game.cur);
    if(game.cur%2 == 0) {
        //SQAUDRE DISPARI (PRIMA, TERZA...) condizione invertita perché l'indice è 0-based
        mini_cl1 += " mini-trans-right mini-side-color-3";
        mini_cl2 += " mini-trans-left mini-side-color-2";
    } else {
        //SQAUDRE PARI (SECONDA, QUARTA...)
        mini_cl1 += " mini-trans-left mini-side-color-1";
        mini_cl2 += " mini-trans-right mini-side-color-2";
    }

    // Prime audio buffers and propagate volume changes to Web Audio gains
    useEffect(() => {
        primeBuffers(displayTracks);
    }, []);

    useEffect(() => {
        return () => {
            stopBgm();
            //display chiuso: i passaggi differiti ancora in attesa non devono più toccare nulla
            //(non è un nodo del DOM: il ref serve proprio a leggere il valore di adesso)
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wordToken.current++;
        };
    }, []);

    useEffect(() => {
        const handleVisibility = () => {
            //la musica non va gestita qui: App sospende l'AudioContext quando la pagina è nascosta
            //e lo riprende al ritorno, quindi il loop si ferma e riparte dallo stesso punto
            if (document.hidden && timerRef.current.active) {
                timerPausedForVisibility.current = true;
                setTimer((prevState) => ({
                    ...prevState,
                    toResume: true,
                    active: false,
                }));
            }
            if (!document.hidden && timerPausedForVisibility.current) {
                timerPausedForVisibility.current = false;
                //il timer riparte solo negli step in cui può girare: se nel frattempo è arrivata una risposta
                //(guessWord) o il tempo è finito non va riavviato
                const timerSteps = [
                    gameStatus_display.newWord,
                    gameStatus_display.guessing,
                    gameStatus_display.double,
                    gameStatus_display.skip,
                ];
                if (timerSteps.includes(game.step)) {
                    setTimer((prevState) => ({
                        ...prevState,
                        active: prevState.toResume,
                        toResume: false,
                    }));
                } else if (game.step !== gameStatus_display.pause) {
                    //in pausa (pulsante disconnesso) toResume serve allo step "resume", altrimenti va azzerato
                    setTimer((prevState) => ({
                        ...prevState,
                        toResume: false,
                    }));
                }
            }
        };
        document.addEventListener('visibilitychange', handleVisibility);
        return () => document.removeEventListener('visibilitychange', handleVisibility);
    }, [game.step]);

    useEffect(() => {
        /* MOSTRA IL NOME DELLA SQUADRA IN GIOCO */
        if(game.step == gameStatus_display.showTeam) {
            //console.log(teams, game.cur);
            setCurTeam(teams[game.cur]);

            setTimeout(() => {
                try {
                    team.current.classList.add("fadein");
                    setTimeout(() => {
                        try {
                            team.current.classList.remove("fadein");
                            team.current.classList.add("fadeout");
                            setTimeout(() => {
                                changeGame((prevState) => ({
                                    ...prevState,
                                    step: 2,
                                }));
                                if (isUnlocked() && !bgmActive.current) {
                                    startBgmLoop();
                                }
                            }, 300);
                        } catch (e) {
                            return;
                        }
                    }, 1500);
                } catch (e) {
                    return;
                }
                
            }, 200);
        }

        /* ENTRA IN SCENA IL BOX DELLA PAROLA, IL TEMPO E IL PUNTEGGIO */
        if(game.step == gameStatus_display.showBox) {
            //animazione e segnale al bottone con firebase
            firebaseCommands.showButton.call(firebaseCommands.creator);

            if (isUnlocked()) {
                playFx('double_up', double_up_audio);
            }
            setTimeout(() => {
                //console.log("CUR 2: ",game.cur);
                if(game.cur%2 == 0) {
                    score.current.classList.add("enterRight");
                    time.current.classList.add("enterLeft");
                } else {
                    score.current.classList.add("enterLeft");
                    time.current.classList.add("enterRight");
                }
                
                setTimeout(() => {
                    score.current.classList.remove("enterLeft");
                    score.current.classList.remove("enterRight");
                    
                    time.current.classList.remove("enterLeft");
                    time.current.classList.remove("enterRight");

                    score.current.style.setProperty("translate", "0px");
                    time.current.style.setProperty("translate", "0px");
                }, 200);
            }, 300);
        }

        /* GENERA UNA NUOVA PAROLA */
        if(game.step == gameStatus_display.newWord) {
            //non puoi usare isDouble per un problema di ripetizione a causa di useEffect
            if(word.current.classList.contains("pop_in")) {
                const token = ++wordToken.current;
                word.current.classList.remove(inputColors.blue);
                if (isUnlocked()) {
                    playFx('double_up', double_up_audio);
                }

                word.current.classList.remove("pop_in");
                word.current.classList.add("pop_out");
                
                score.current.classList.remove("shiftLeft_in");
                score.current.classList.remove("shiftRight_in");
                time.current.classList.remove("shiftLeft_in");
                time.current.classList.remove("shiftRight_in");

                if(game.cur%2 == 0) {
                    score.current.classList.add("shiftRight_out");
                    time.current.classList.add("shiftLeft_out");
                } else {
                    score.current.classList.add("shiftLeft_out");
                    time.current.classList.add("shiftRight_out");
                }                

                changeGame(prevState => ({
                    ...prevState,
                    step: gameStatus_display.guessing
                }));

                setTimeout(() => {
                    if (!word.current) return;   //display chiuso nel frattempo
                    //mostra una parola a caso (se nel frattempo non è partita un'altra parola)
                    if (token === wordToken.current) {
                        word.current.querySelector("span").innerHTML = getRandomWord();
                    }

                    setTimeout(() => {
                        if (!word.current) return;
                        score.current.classList.remove("shiftLeft_out");
                        score.current.classList.remove("shiftRight_out");
                        time.current.classList.remove("shiftLeft_out");
                        time.current.classList.remove("shiftRight_out");
                        word.current.classList.remove("pop_out");

                        startTimerFor(token);
                    }, 250);
                }, 250);

            } else {
                wordClass = "wordContainer "+ inputColors.done;
                word.current.className = wordClass;

                if (isUnlocked()) {
                    playFx('new_word', new_word_audio);
                }
                const token = ++wordToken.current;
                randomWords(word.current).then(() => {
                    //superata da un'altra parola, oppure display chiuso
                    if (token !== wordToken.current) return;
                    //mostra una parola a caso
                    word.current.querySelector("span").innerHTML = getRandomWord();

                    startTimerFor(token);
                });
            }
            
        }

        /* FERMA IL TIMER, È IL MOMENTO DI INDOVINARE */
        if(game.step == gameStatus_display.guessWord) {
            if (isUnlocked()) {
                playFx('ready', ready_audio);
            }

            //inserisci un timer di 6 secondi
            //dopodiché la risposta è sbagliata
            setTimer((prevState) => ({
                ...prevState,
                active: false,
            }));

            /* setTurnTimer((prevState) => ({  //timer turno
                ...prevState,
                active: true,
                timeLeft: 6
            })); */
        }

        /* PAROLA SBAGLIATA */
        if(game.step == gameStatus_display.wrong) {
            if (isUnlocked()) {
                playFx('wrong', wrong_audio);
            }
            /* setTurnTimer((prevState) => ({  //timer turno
                ...prevState,
                active: false,
                timeLeft: 6
            })); */

            let wt = 80;

            setTimeout(() => {
                word.current.classList.add(inputColors.error);

                setTimeout(() => {
                    word.current.classList.remove(inputColors.error);

                    setTimeout(() => {
                        word.current.classList.add(inputColors.error);

                        setTimeout(() => {
                            word.current.classList.remove(inputColors.error);

                        }, wt);
                    }, wt);
                }, wt);
            }, wt);

            if(curTeam.score > 0) {
                let newList = [...teams];
                newList[game.cur] = {
                    name: newList[game.cur].name,
                    score: newList[game.cur].score - (word.current.classList.contains("pop_in") ? 2 : 1)
                }
                changeTeams(newList);
            }
        }

        /* PAROLA CORRETTA */
        if(game.step == gameStatus_display.correct) {
            if (isUnlocked()) {
                playFx('correct', correct_audio);
            }
            /* setTurnTimer((prevState) => ({  //timer turno
                ...prevState,
                active: false,
                timeLeft: 6
            })); */

            let wt = 80;

            setTimeout(() => {
                word.current.classList.add(inputColors.blue);

                setTimeout(() => {
                    word.current.classList.remove(inputColors.blue);

                    setTimeout(() => {
                        word.current.classList.add(inputColors.blue);

                        setTimeout(() => {
                            word.current.classList.remove(inputColors.blue);

                            setTimeout(() => {
                                word.current.classList.add(inputColors.blue);
                                
                            }, wt);
                        }, wt);
                    }, wt);
                }, wt);
            }, wt);
            

            let newList = [...teams];
                newList[game.cur] = {
                    name: newList[game.cur].name,
                    score: newList[game.cur].score + (word.current.classList.contains("pop_in") ? 2 : 1)
                }
            changeTeams(newList);
        }

        /* HA USATO UN PASSO */
        if(game.step == gameStatus_display.skip) {
            /* setTurnTimer((prevState) => ({  //timer turno
                ...prevState,
                active: false,
                timeLeft: 6
            })); */
        }

        /* HA USATO UN RADDOPPIO */
        if(game.step == gameStatus_display.double) {
            if (isUnlocked()) {
                playFx('double_up', double_up_audio);
            }

            wordClass = "wordContainer "+ inputColors.done;
            word.current.className = wordClass;
            word.current.classList.add("pop_in");

            if(game.cur%2 == 0) {
                score.current.classList.add("shiftRight_in");
                time.current.classList.add("shiftLeft_in");
            } else {
                score.current.classList.add("shiftLeft_in");
                time.current.classList.add("shiftRight_in");
            }
            

            //se nel frattempo parte un'altra parola (o il display si chiude) questa non deve più mostrarsi né avviare il timer
            const token = ++wordToken.current;
            setTimeout(() => {
                if (token !== wordToken.current) return;
                //mostra una parola a caso
                word.current.querySelector("span").innerHTML = getRandomWord(true);

                setTimeout(() => {
                    startTimerFor(token);
                }, 250);
            }, 250);
        }

        /* DEVE VISUALIZZARE I RISULTATI */
        if(game.step == gameStatus_display.showResults) {
            stopBgmLoop();
            stopBgm();
            if(!game.isLast && isUnlocked() && !showScoreSequencePlayed.current) {
                showScoreSequencePlayed.current = true;
                void (async () => {
                    const startAt = getAudioTime() + 0.05;
                    const duration = await getBufferDuration('showScore', showScore_audio_1);
                    await playFx('showScore', showScore_audio_1, { target: 'music', startAt });
                    if (nextCutsceneTrack?.url) {
                        await playFx(nextCutsceneTrack.name, nextCutsceneTrack.url, {
                            target: 'music',
                            startAt: startAt + duration,
                        });
                        if (typeof setCutsceneAudioExternal === 'function') {
                            setCutsceneAudioExternal(true);
                        }
                    }
                })();
            }

            const box = document.querySelector(".bottomBox");
            box.classList.remove("showUp");
            box.classList.add("hideDown");

            score.current.classList.add("hideDown");
            time.current.classList.add("hideDown");
        }

        if (game.step != gameStatus_display.showResults) {
            showScoreSequencePlayed.current = false;
        }

        /* IL PULSANTE SI È DISCONNESSO */
        if(game.step == gameStatus_display.pause) {
            if(timer.active) {
                setTimer(prevState => ({
                    ...prevState,
                    toResume: timer.active,
                    active: false
                }));
            }
            
            if(turnTimer.active) {
                /* setTurnTimer(prevState => ({
                    ...prevState,
                    toResume: turnTimer.active,
                    active: false
                })); */
            }
            
        }

        /* IL PULSANTE SI È CONNESSO NUOVAMENTE */
        if(game.step == gameStatus_display.resume) {
            setTimer(prevState => ({
                ...prevState,
                active: timer.toResume,
                toResume: false,
            }));

            if(game.prevStep == gameStatus_display.guessWord ||
                game.prevStep == gameStatus_display.lastGuess ||
                game.prevStep == gameStatus_display.showTeam) {
                changeGame(prevState => ({
                    ...prevState,
                    step: game.prevStep
                }));
            }
            
            
            /* setTurnTimer(prevState => ({
                ...prevState,
                active: turnTimer.toResume,
                toResume: false,
            })); */
            
        }
    }, [game]);

    useEffect(() => {
        if(game.cur != -1) {
            setCurTeam(teams[game.cur]);
        }
    }, [teams]);

    const getRandomWord = (double=false) => {
        const wordList = double ? doubleWords : words;
        const readKeysList = double ? readDoubleKeys : readKeys;
        const setReadKeysList = double ? setReadDoubleKeys : setReadKeys;
        const customWordList = double ? customDoubleWords : customWords;
        const customReadKeysList = double ? readCustomDoubleKeys : readCustomKeys;
        const setCustomReadKeysList = double ? setCustomReadDoubleKeys : setCustomReadKeys;
        const forceStds = double ? forceDoubleStandards : forceStandards

        //possibile parola vuota o ciclo infinito
        //console.log(words, customWords, doubleWords, customDoubleWords);
    
        //console.log(double ? "double words picked" : "single words picked");
    
        // Determina se pescare dalle liste custom o dalle liste normali
        let p = (1 - percent).toFixed(1);
        let useCustom = Math.random() < (forceStds ? 0.3 : p);

        if((useCustom && customWordList.length == 0) || (!useCustom && wordList.length == 0)) {
            useCustom = !useCustom;
        }

        //console.log("using custom: ", useCustom);

        let selectedWordList, selectedReadKeysList, selectedSetReadKeysList;

        if (useCustom) {
            selectedWordList = customWordList;
            selectedReadKeysList = customReadKeysList;
            selectedSetReadKeysList = setCustomReadKeysList;
        } else {
            selectedWordList = wordList;
            selectedReadKeysList = readKeysList;
            selectedSetReadKeysList = setReadKeysList;
        }

        // Se tutte le parole sono state lette, resetta l'array selectedReadKeysList
        //console.log(selectedReadKeysList.length, selectedWordList.length);
        if (selectedReadKeysList.length === selectedWordList.length) {
            selectedReadKeysList = [];
            selectedSetReadKeysList([]);
        }
        
        let randomWord;
        //console.log(selectedReadKeysList.length, selectedWordList.length);
        do {
            randomWord = selectedWordList[Math.floor(Math.random() * selectedWordList.length)];
        } while (selectedReadKeysList.includes(randomWord));

        // Aggiungi la parola selezionata all'array selectedReadKeysList
        selectedSetReadKeysList(prevReadKeys => [...prevReadKeys, randomWord]);

        return randomWord;
    }

    const formatTime = (time) => {
        return time < 10 ? `:0${time}` : ":"+time.toString();
    };

    const stopBgmLoop = () => {
        bgmActive.current = false;
        bgmToken.current++;
        stopBgm();
    };

    const startBgmLoop = () => {
        if (bgmActive.current) return;
        bgmActive.current = true;
        const token = ++bgmToken.current;
        //l'intro si suona una volta, poi il motore audio ripete [BGM_LOOP_START, BGM_LOOP_END) senza schedulazioni
        playBgm('bgm', bgm_audio, { loop: true, loopStart: BGM_LOOP_START, loopEnd: BGM_LOOP_END }).then((src) => {
            //se nel frattempo è stata fermata (il file era ancora in caricamento) questa riproduzione non serve più
            if (src && token !== bgmToken.current) {
                try { src.stop(); } catch (_) { /* noop */ }
            }
        });
    };

    const turnEnded = () => {
        if (isUnlocked()) {
            playFx('time_out', time_out_audio);
        }
        //invia comando al bottone per rispondere
        //deve dare la possibilità di non rispondere
        firebaseCommands.turnEnded.call(firebaseCommands.creator);
        setTimer((prevState) => ({
            ...prevState,
            active: false,
        }));

        /* setTurnTimer((prevState) => ({  //timer turno
            ...prevState,
            active: true,
            timeLeft: 6
        })); */

        changeGame((prevState) => ({
            ...prevState,
            step: gameStatus_display.lastGuess,
        }));
        
    }

    return (
        <div className='game_display'>
            {(game.step == gameStatus_display.showTeam) && <div className='curTeam' ref={team}>
                <span className='title-txt'>GIOCANO:</span>
                
                <div className='wordContainer common-btn-orange'>
                    <span className='common-btn-txt'>{curTeam.name}</span>
                </div>
            </div>}

            {game.step >= 2 && <div className='gameView'>
                <div className='bottomBox showUp'>
                    {/* SQAUDRE PARI (SECONDA, QUARTA...) */}
                    {game.cur%2 != 0 && <div className='gameUI'>
                        <div className={mini_cl1} id='score' ref={score}>
                            <span className='score-txt'>{curTeam.score}</span>
                        </div>

                        <div className={wordClass} id='word' ref={word}>
                            <span className='game-word'>PREMI IL PULSANTE</span>
                        </div>

                        <div className={mini_cl2} id='time' ref={time}>
                            <span className='timer-txt'>{formatTime(timer.timeLeft)}</span>
                        </div>
                    </div>}
                    
                    {/* SQAUDRE DISPARI (PRIMA, TERZA...) condizione invertita perché l'indice è 0-based */}
                    {game.cur%2 == 0 && <div className='gameUI'>
                        <div className={mini_cl2} id='time' ref={time}>
                            <span className='timer-txt'>{formatTime(timer.timeLeft)}</span>
                        </div>

                        <div className={wordClass} id='word' ref={word}>
                            <span className='game-word'>PREMI IL PULSANTE</span>
                        </div>

                        <div className={mini_cl1} id='score' ref={score}>
                            <span className='score-txt'>{curTeam.score}</span>
                        </div>
                    </div>}
                </div>
                
                {/* TIMER PARTITA */}
                {timer.active && <TimerComponent
                    onTimerEnd = {turnEnded}
                    onTimeUpdate = {(time) => {
                        setTimer((prevState) => ({
                            ...prevState,
                            timeLeft: time
                        }));
                    }}
                    initialTime={timer.timeLeft}
                ></TimerComponent>}

                {/* TIMER TURNO */}
                {turnTimer.active && <TimerComponent
                    onTimerEnd = {() => {
                        // setTurnTimer({active: false});
                        if(game.step == gameStatus_display.guessWord) {
                            firebaseCommands.wrong.call(firebaseCommands.reciver);
                            firebaseCommands.cancelAnswer.call(firebaseCommands.creator);
                        } else {
                            firebaseCommands.showResults.call(firebaseCommands.creator);
                        }

                    }}
                    onTimeUpdate = {(time) => {
                        /* setTurnTimer((prevState) => ({
                            ...prevState,
                            timeLeft: time,
                        })); */
                    }}
                    initialTime={turnTimer.timeLeft}
                ></TimerComponent>}
                

                {turnTimer.active && turnTimer.timeLeft < 4 && <div className="turnTimer-bg">
                    <div className={"turnTimer "+btnColors.orange}>
                        <span className='turnTimer-text'>{turnTimer.timeLeft}</span>
                    </div>
                </div>}
            </div>}



            {/* AUDIO SOUNDS */}
        </div>
    );
}

function randomLetter() {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return alphabet[Math.floor(Math.random() * alphabet.length)];
}

function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

async function randomWords(word) {
    for (let i = 0; i < 10; i++) {
        let s = "";
        let n = Math.floor(Math.random() * 3) + 5
        for(let j = 0; j<n; j++) {
            s += randomLetter();
        }
        word.querySelector("span").innerHTML = s;
        await wait(50);
    }
}

export default Game_display;